import './Grid.scss'
import { useWindowSize } from '@uidotdev/usehooks'
import { clsx } from 'clsx'
import type { ReactNode } from 'react'
import { GridDuplexCellComponent } from '#src/components/GridDuplexCellComponent.js'
import { GridSingleCellComponent } from '#src/components/GridSingleCellComponent.js'
import type { Gallery, GridData } from '#src/data/data.js'
import { isDuplexCell, isImageGallery, isSingleCell, isVideoGallery } from '#src/dataService.js'

interface Props {
  grid: GridData
  /**
   * Defaults to false
   */
  leftRight?: boolean
  galleryPath: string
}

export function Grid(props: Props): ReactNode {
  const windowSize = useWindowSize()
  const innerWidth = windowSize.width || 0
  const isMobile = innerWidth <= 600

  const allGalleries: Gallery[] = []

  props.grid.cells.forEach(cell => {
    if (isSingleCell(cell)) {
      allGalleries.push(cell.gallery)
    } else if (isDuplexCell(cell)) {
      allGalleries.push(...cell.galleries)
    }
  })

  assignLeftRight(allGalleries, isMobile)

  return (
    <section
      className={clsx('grid', {
        'grid_left-right': !!props.leftRight,
      })}
    >
      {props.grid.cells.map(cell => {
        if (isSingleCell(cell)) {
          return (
            <GridSingleCellComponent key={cell.id} cell={cell} galleryPath={props.galleryPath} />
          )
        }
        if (isDuplexCell(cell)) {
          return (
            <GridDuplexCellComponent key={cell.id} cell={cell} galleryPath={props.galleryPath} />
          )
        }
      })}
    </section>
  )
}

function assignLeftRight(galleries: Gallery[], isMobile: boolean): void {
  if (!isMobile) {
    // clear left/right
    galleries.forEach(g => {
      g.left = false
      g.right = false
    })
    return
  }

  let left = true
  galleries.forEach(g => {
    const horizontal =
      (isImageGallery(g) && g.cover?.tags?.includes('horizontal')) ||
      (isVideoGallery(g) && g.horizontal)
    if (horizontal) {
      return // skip
    }

    if (left) {
      g.left = true
      left = false
    } else {
      g.right = true
      left = true
    }
  })
}
